import { NgModule } from '@angular/core';
import { CapitalizeModule } from '@app/shared/pipes/capitalize/capitalize.module';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { DateFormatPipe } from './dateFormat.pipe';
import { ElementPipeModule } from './element/element.module';
import { FamilyCompositionPipeModule } from './family-composition/family-composition.module';
import { KilometerPipe } from './kilometer.pipe';
import { KilometragePipe } from './kilometrage.pipe';
import { LicenseplatePipeModule } from './licenseplate/licenseplate.module';
import { MileageCarPipeModule } from './mileage-car/mileage-car.module';
import { MileageMotorcycle } from './mileage-motorcycle';
import { PrettyPricePipeModule } from './pretty-price/pretty-price.module';
import { SanitizePipeModule } from './sanitize/sanitize.module';
import { TimePipe } from './time.pipe';

/** @deprecated - this is moved to libs */
@NgModule({
    imports: [
        ElementPipeModule,
        SanitizePipeModule,
        LicenseplatePipeModule,
        FamilyCompositionPipeModule,
        MileageCarPipeModule,
        PrettyPricePipeModule,
        CapitalizeModule,
    ],
    exports: [
        CapitalizePipe,
        KilometerPipe,
        KilometragePipe,
        DateFormatPipe,
        TimePipe,
        MileageMotorcycle,
        ElementPipeModule,
        SanitizePipeModule,
        LicenseplatePipeModule,
        FamilyCompositionPipeModule,
        MileageCarPipeModule,
        PrettyPricePipeModule,
        CapitalizeModule,
    ],
    declarations: [
        KilometerPipe,
        KilometragePipe,
        DateFormatPipe,
        TimePipe,
        MileageMotorcycle,
    ],
})

export class PipesModule { }
